/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as Clear_cacheRouteImport } from './routes/clear_cache'
import { Route as IeRouteImport } from './routes/ie'
import { Route as MaintenanceRouteImport } from './routes/maintenance'
import { Route as Sign_inRouteImport } from './routes/sign_in'
import { Route as Sign_outRouteImport } from './routes/sign_out'
import { Route as TTenant_idRouteRouteImport } from './routes/t/$tenant_id/route'
import { Route as TTenant_idIndexRouteImport } from './routes/t/$tenant_id/index'
import { Route as TTenant_idMillsheetScanRouteImport } from './routes/t/$tenant_id/millsheet/scan'
import { Route as TTenant_idMillsheetHistoryIndexRouteImport } from './routes/t/$tenant_id/millsheet/history/index'
import { Route as TTenant_idMillsheetHistoryResult_idRouteImport } from './routes/t/$tenant_id/millsheet/history/$result_id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const Clear_cacheRoute = Clear_cacheRouteImport.update({
  id: '/clear_cache',
  path: '/clear_cache',
  getParentRoute: () => rootRouteImport,
} as any)
const IeRoute = IeRouteImport.update({
  id: '/ie',
  path: '/ie',
  getParentRoute: () => rootRouteImport,
} as any)
const MaintenanceRoute = MaintenanceRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => rootRouteImport,
} as any)
const Sign_inRoute = Sign_inRouteImport.update({
  id: '/sign_in',
  path: '/sign_in',
  getParentRoute: () => rootRouteImport,
} as any)
const Sign_outRoute = Sign_outRouteImport.update({
  id: '/sign_out',
  path: '/sign_out',
  getParentRoute: () => rootRouteImport,
} as any)
const TTenant_idRouteRoute = TTenant_idRouteRouteImport.update({
  id: '/t/$tenant_id',
  path: '/t/$tenant_id',
  getParentRoute: () => rootRouteImport,
} as any)
const TTenant_idIndexRoute = TTenant_idIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TTenant_idRouteRoute,
} as any)
const TTenant_idMillsheetScanRoute = TTenant_idMillsheetScanRouteImport.update({
  id: '/millsheet/scan',
  path: '/millsheet/scan',
  getParentRoute: () => TTenant_idRouteRoute,
} as any)
const TTenant_idMillsheetHistoryIndexRoute =
  TTenant_idMillsheetHistoryIndexRouteImport.update({
    id: '/millsheet/history/',
    path: '/millsheet/history/',
    getParentRoute: () => TTenant_idRouteRoute,
  } as any)
const TTenant_idMillsheetHistoryResult_idRoute =
  TTenant_idMillsheetHistoryResult_idRouteImport.update({
    id: '/millsheet/history/$result_id',
    path: '/millsheet/history/$result_id',
    getParentRoute: () => TTenant_idRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/clear_cache': typeof Clear_cacheRoute
  '/ie': typeof IeRoute
  '/maintenance': typeof MaintenanceRoute
  '/sign_in': typeof Sign_inRoute
  '/sign_out': typeof Sign_outRoute
  '/t/$tenant_id': typeof TTenant_idRouteRouteWithChildren
  '/t/$tenant_id/': typeof TTenant_idIndexRoute
  '/t/$tenant_id/millsheet/scan': typeof TTenant_idMillsheetScanRoute
  '/t/$tenant_id/millsheet/history/$result_id': typeof TTenant_idMillsheetHistoryResult_idRoute
  '/t/$tenant_id/millsheet/history/': typeof TTenant_idMillsheetHistoryIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/clear_cache': typeof Clear_cacheRoute
  '/ie': typeof IeRoute
  '/maintenance': typeof MaintenanceRoute
  '/sign_in': typeof Sign_inRoute
  '/sign_out': typeof Sign_outRoute
  '/t/$tenant_id': typeof TTenant_idIndexRoute
  '/t/$tenant_id/millsheet/scan': typeof TTenant_idMillsheetScanRoute
  '/t/$tenant_id/millsheet/history/$result_id': typeof TTenant_idMillsheetHistoryResult_idRoute
  '/t/$tenant_id/millsheet/history': typeof TTenant_idMillsheetHistoryIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/clear_cache': typeof Clear_cacheRoute
  '/ie': typeof IeRoute
  '/maintenance': typeof MaintenanceRoute
  '/sign_in': typeof Sign_inRoute
  '/sign_out': typeof Sign_outRoute
  '/t/$tenant_id': typeof TTenant_idRouteRouteWithChildren
  '/t/$tenant_id/': typeof TTenant_idIndexRoute
  '/t/$tenant_id/millsheet/scan': typeof TTenant_idMillsheetScanRoute
  '/t/$tenant_id/millsheet/history/$result_id': typeof TTenant_idMillsheetHistoryResult_idRoute
  '/t/$tenant_id/millsheet/history/': typeof TTenant_idMillsheetHistoryIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/clear_cache'
    | '/ie'
    | '/maintenance'
    | '/sign_in'
    | '/sign_out'
    | '/t/$tenant_id'
    | '/t/$tenant_id/'
    | '/t/$tenant_id/millsheet/scan'
    | '/t/$tenant_id/millsheet/history/$result_id'
    | '/t/$tenant_id/millsheet/history/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/clear_cache'
    | '/ie'
    | '/maintenance'
    | '/sign_in'
    | '/sign_out'
    | '/t/$tenant_id'
    | '/t/$tenant_id/millsheet/scan'
    | '/t/$tenant_id/millsheet/history/$result_id'
    | '/t/$tenant_id/millsheet/history'
  id:
    | '__root__'
    | '/'
    | '/clear_cache'
    | '/ie'
    | '/maintenance'
    | '/sign_in'
    | '/sign_out'
    | '/t/$tenant_id'
    | '/t/$tenant_id/'
    | '/t/$tenant_id/millsheet/scan'
    | '/t/$tenant_id/millsheet/history/$result_id'
    | '/t/$tenant_id/millsheet/history/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  Clear_cacheRoute: typeof Clear_cacheRoute
  IeRoute: typeof IeRoute
  MaintenanceRoute: typeof MaintenanceRoute
  Sign_inRoute: typeof Sign_inRoute
  Sign_outRoute: typeof Sign_outRoute
  TTenant_idRouteRoute: typeof TTenant_idRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clear_cache': {
      id: '/clear_cache'
      path: '/clear_cache'
      fullPath: '/clear_cache'
      preLoaderRoute: typeof Clear_cacheRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ie': {
      id: '/ie'
      path: '/ie'
      fullPath: '/ie'
      preLoaderRoute: typeof IeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maintenance': {
      id: '/maintenance'
      path: '/maintenance'
      fullPath: '/maintenance'
      preLoaderRoute: typeof MaintenanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign_in': {
      id: '/sign_in'
      path: '/sign_in'
      fullPath: '/sign_in'
      preLoaderRoute: typeof Sign_inRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign_out': {
      id: '/sign_out'
      path: '/sign_out'
      fullPath: '/sign_out'
      preLoaderRoute: typeof Sign_outRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/t/$tenant_id': {
      id: '/t/$tenant_id'
      path: '/t/$tenant_id'
      fullPath: '/t/$tenant_id'
      preLoaderRoute: typeof TTenant_idRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/t/$tenant_id/': {
      id: '/t/$tenant_id/'
      path: '/'
      fullPath: '/t/$tenant_id/'
      preLoaderRoute: typeof TTenant_idIndexRouteImport
      parentRoute: typeof TTenant_idRouteRoute
    }
    '/t/$tenant_id/millsheet/scan': {
      id: '/t/$tenant_id/millsheet/scan'
      path: '/millsheet/scan'
      fullPath: '/t/$tenant_id/millsheet/scan'
      preLoaderRoute: typeof TTenant_idMillsheetScanRouteImport
      parentRoute: typeof TTenant_idRouteRoute
    }
    '/t/$tenant_id/millsheet/history/': {
      id: '/t/$tenant_id/millsheet/history/'
      path: '/millsheet/history'
      fullPath: '/t/$tenant_id/millsheet/history/'
      preLoaderRoute: typeof TTenant_idMillsheetHistoryIndexRouteImport
      parentRoute: typeof TTenant_idRouteRoute
    }
    '/t/$tenant_id/millsheet/history/$result_id': {
      id: '/t/$tenant_id/millsheet/history/$result_id'
      path: '/millsheet/history/$result_id'
      fullPath: '/t/$tenant_id/millsheet/history/$result_id'
      preLoaderRoute: typeof TTenant_idMillsheetHistoryResult_idRouteImport
      parentRoute: typeof TTenant_idRouteRoute
    }
  }
}

interface TTenant_idRouteRouteChildren {
  TTenant_idIndexRoute: typeof TTenant_idIndexRoute
  TTenant_idMillsheetScanRoute: typeof TTenant_idMillsheetScanRoute
  TTenant_idMillsheetHistoryResult_idRoute: typeof TTenant_idMillsheetHistoryResult_idRoute
  TTenant_idMillsheetHistoryIndexRoute: typeof TTenant_idMillsheetHistoryIndexRoute
}

const TTenant_idRouteRouteChildren: TTenant_idRouteRouteChildren = {
  TTenant_idIndexRoute: TTenant_idIndexRoute,
  TTenant_idMillsheetScanRoute: TTenant_idMillsheetScanRoute,
  TTenant_idMillsheetHistoryResult_idRoute:
    TTenant_idMillsheetHistoryResult_idRoute,
  TTenant_idMillsheetHistoryIndexRoute: TTenant_idMillsheetHistoryIndexRoute,
}

const TTenant_idRouteRouteWithChildren = TTenant_idRouteRoute._addFileChildren(
  TTenant_idRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  Clear_cacheRoute: Clear_cacheRoute,
  IeRoute: IeRoute,
  MaintenanceRoute: MaintenanceRoute,
  Sign_inRoute: Sign_inRoute,
  Sign_outRoute: Sign_outRoute,
  TTenant_idRouteRoute: TTenant_idRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
